<template>
    <div class="col-xl-12 float-left background-fff mb-3 roi-widget order-notes padding15">
        <h6 class="proxima-nova-bold float-left">Notes</h6>
        <ul id="comments" style="clear: both">
            <li v-for="note in notes">
                <span>
                    <div class="row">
                        <div class="avatar col-sm-2">
                            <img :src="note.user.image" :alt="note.user.name" />
                        </div>
                        <div class="col-sm-10">
                            <div class="position-absolute text-right" style="right: 5px;">
                                <a @click="togglePinNote(note)" class="icon-btn">
                                  <i :class="note.pin ? 'fas fa-thumbtack text-primary' : 'fas fa-thumbtack'"></i>
                                </a>
                                <a @click="edit(note)" class="icon-btn">
                                    <i class="fa fa-pen text-secondary"></i>
                                </a>
                                <a @click="deleteNote(note)" class="icon-btn">
                                    <i class="fa fa-trash text-danger"></i>
                                </a>
                            </div>
                            <h6>{{ note.user.name }}</h6>
                            <span class="date mt-0 d-block">
                                {{ note.updated_at | formatDate }}
                            </span>
                            <div v-if="tempNote.id === note.id" class="form-row">
                                <div class="col-12">
                                    <Mentionable :keys="['@']" :items="mentionItems" offset="6" insert-space>
                                        <textarea v-model="tempNote.text" class="form-control form-control-sm mt-2 mb-2" cols="30" rows="3" />
                                        <template #item-@="{ item }">
                                            <div class="recipients">
                                                <span class="dim">
                                                  {{ item.name }}
                                                </span>
                                            </div>
                                        </template>
                                    </Mentionable>
                                </div>
                                <div class="col-12">
                                    <button @click="submit(note)" class="btn btn-primary" :disabled="loading">Submit</button>
                                    <button @click="tempNote = {}" class="btn">Cancel</button>
                                </div>
                            </div>
                            <span v-else class="d-block mt-2">{{ note.text }}</span>
                        </div>
                    </div>
                </span>
            </li>
            <li v-if="notes.length === 0" class="m-0 pt-2 border-0" style="text-align: center;margin: 35px;margin-bottom: 7px">
                Be the first to add a note!
            </li>
        </ul>
        <div class="clearfix"></div>
        <div class="float-right mt-3 mb-3">
            <pager v-if="total > itemsPerPage" :total="total" :items-per-page="itemsPerPage" :current-page="currentPage" @on-page-change="onPageChange" />
        </div>
        <div class="clearfix"></div>
        <div class="form-row">
            <div class="col-12">
                <Mentionable :keys="['@']" :items="mentionItems" offset="6" insert-space>
                    <textarea v-model="comment" class="form-control form-control-sm mt-2 mb-2" cols="30" rows="3"/>
                    <template #item-@="{ item }">
                        <div class="recipients">
                            <span class="dim">
                              {{ item.name }}
                            </span>
                        </div>
                    </template>
                </Mentionable>
            </div>
            <div class="col-12">
                <button @click="add" class="btn btn-primary" :disabled="addLoading">Add Note</button>
            </div>
        </div>
    </div>
</template>

<script>
import { Mentionable } from 'vue-mention';
import moment from 'moment';

export default {
    components: {
        Mentionable,
    },
    props: ['orderNumber', 'users'],
    data: function () {
        return {
            notes: [],
            total: 0,
            currentPage: 0,
            itemsPerPage: 0,
            tempNote: {},
            comment: '',
            loading: false,
            addLoading: false,
        };
    },
    mounted() {
        this.loadNotes(1);
    },
    computed: {
      mentionItems() {
          const ret = [];
          this.users.forEach((user) => {
              ret.push({
                  value: user.name.toLowerCase().replace(' ', '.'),
                  name: user.name,
              });
          });
          return ret;
      }
    },
    methods: {
        loadNotes(page) {
            this.$http.get(`/orders/${this.orderNumber}/notes?page=${page}`).then((res) => {
                this.notes = res.data.data;
                this.total = res.data.total;
                this.currentPage = res.data.current_page;
                this.itemsPerPage = res.data.per_page;
            });
        },
        edit(note) {
            this.tempNote = JSON.parse(JSON.stringify(note));
        },
        submit(note) {
            this.loading = true;
            this.$http.put(`/orders/${this.orderNumber}/notes/${this.tempNote.id}`, {
                text: this.tempNote.text,
            }).then((res) => {
                note.text = res.data.text;
                note.updated_at = res.data.updated_at;
                this.tempNote = {};
                this.loading = false;
            }).catch((e) => {
                console.log(e);
                this.loading = false;
            });
        },
        add() {
            if (this.comment && this.comment !== '') {
                this.addLoading = true;
                this.$http.post(`/orders/${this.orderNumber}/notes`, {
                    text: this.comment,
                }).then((res) => {
                    this.comment = '';
                    this.addLoading = false;
                    this.loadNotes(this.currentPage);
                }).catch((e) => {
                    console.log(e);
                });
            }
        },
        deleteNote(note) {
            if (confirm('Are you sure you want to delete this note?')) {
                this.loading = true;
                this.$http.delete(`/orders/${this.orderNumber}/notes/${note.id}`, {}).then((res) => {
                    this.loading = false;
                    this.loadNotes(this.currentPage);
                }).catch((e) => {
                    console.log(e);
                    this.loading = false;
                });
            }
        },
        togglePinNote(note) {
            this.loading = true;
            this.$http.put(`/orders/${this.orderNumber}/notes/${note.id}/togglePin`, {
                text: this.comment,
            }).then((res) => {
                this.loading = false;
                this.loadNotes(this.currentPage);
            }).catch((e) => {
                console.log(e);
                this.loading = false;
            });
        },
        cancel() {
            this.tempNote = {};
        },
        onPageChange(page) {
            this.loadNotes(page);
        },
    },
    filters: {
        formatDate(date) {
            return `${moment(date).format('DD MMM HH:mm')} (${moment(date).fromNow()})`;
        }
    }
}
</script>

<style scoped>
.order-notes ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.order-notes ul li {
    padding: 10px;
    border-bottom: 2px solid #f1f2f4;
}

.order-notes ul li:nth-child(2n) {
    background-color: #FAFBFD;
}

.order-notes .date {
    color: #999;
    font-size: 12px;
    line-height: 12px;
}
.icon-btn {
    cursor: pointer;
    width: 20px;
    margin: 0 5px;
}
</style>

<style>
.mention-item {
    padding: 4px 4px;
    border-radius: 4px;
    cursor: pointer;
}
.mention-selected {
    background: rgb(212, 218, 231);
}

.tooltip .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
}

.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
}

.tooltip[x-placement^="top"] {
    margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
    margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
    margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}

.tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: black;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
}
</style>
